import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { check } from "../modules/auth";
import LoadingForm from "../components/LoadingForm";
import jQuery from "jquery";

const LoadingContainer = ({ history }) => {
  const dispatch = useDispatch();
  const { auth, authError } = useSelector(({ auth }) => ({
    auth: auth.auth,
    authError: auth.authError,
  }));

  useEffect(() => {
    dispatch(check());
  }, [dispatch]);

  // jquery로 퍼블리싱된 html을 사용하기 위해 jquery를 직접 import하고 innerHTML로 강제 할당함.
  useEffect(() => {
    if (authError) {
      return;
    } else if (auth) {
      const script = document.createElement("script");
      window.$ = window.jQuery = jQuery;
      script.innerHTML = `
        ! function(t, e, n) {
          "use strict";

          function a(e, n) {
            this.$el = t(e), this.$el.data(s, this), this.defaults = {
              content: "",
              speed: 100,
              removeAt: 0,
              deleteNo: 0,
              callback: ""
            };
            var a = this.$el.data(s + "-opts");
            this.opts = t.extend(this.defaults, n, a), this.init()
          }
          var s = "type-it";
          a.prototype.init = function() {
            var e = this,
              n = this.$el,
              s = [],
              a = this.opts.content,
              i = this.opts.speed,
              o = i * a.length;
            if (n.empty(), n.addClass("typing"), 0 == e.opts.removeAt || 0 == e.opts.removeAt) {
              for (var p = 0; p < a.length; p++) s.push(a[p]);
              t.each(s, function(t, e) {
                setTimeout(function() {
                  n.append("<span>" + e + "</span>")
                }, t * i)
              })
            } else {
              for (var p = 0; p < a.length; p++) s.push(a[p]);
              t.each(s, function(t, s) {
                t < e.opts.removeAt && n.append('<span data-timing="' + t * i + '" style="display: none;">' + s + "</span>")
              });
              for (var r = 1, p = e.opts.removeAt - e.opts.deleteNo; p < e.opts.removeAt; p++) {
                var l = n.find("span").last().attr("data-timing");
                n.find("span").eq(p).attr("data-delete", parseInt(l) + parseInt(i * r)), r += 1
              }
              t.each(s, function(t, s) {
                t >= e.opts.removeAt && n.append('<span data-timing="' + (t + e.opts.deleteNo) * i + '" style="display: none;">' + s + "</span>")
              });
              var d = {},
                f = jQuery.makeArray(n.find("span"));
              t.each(f, function(t, e) {
                d[e.dataset.timing] = 1, d[e.dataset["delete"]] = -1
              });
              var r = 0,
                c = parseInt(e.opts.removeAt),
                o = o + parseInt(e.opts.deleteNo * i),
                u = !1;
              t.each(d, function(t, e) {
                setTimeout(function() {
                  1 == e && 0 == u ? (n.find("span").eq(r).css("display", "inline"), r += 1) : 1 == e && 1 == u ? (n.find("span").eq(c).css("display", "inline"), c += 1) : (n.find("span").eq(r).css("display", "none"), r -= 1), r == c - 1 && (u = !0)
                }, t)
              })
            }
            setTimeout(function() {
              e.opts.callback && e.opts.callback()
            }, o)
          }, t.fn.typeIt = function(t) {
            return this.each(function() {
              new a(this, t)
            })
          }
        }(jQuery, document, window);

        function type1(){
          var typeit1 = $('.type-it-1');
          function go() {
            typeit1.addClass('on');
            typeit1.typeIt({
              content : '학생의 프로필 정보를 분석 중입니다···',
            });
          }
          go();
        }
        function type2(){
          var typeit2 = $('.type-it-2');
          function go() {
            typeit2.addClass('on');
            typeit2.typeIt({
              content : 'AI스캐닝에 필요한 정보를 최적화 하는 중입니다···',
            });
          }
          go();
        }
        function type3(){
          var typeit2 = $('.type-it-3');
          function go() {
            typeit2.addClass('on');
            typeit2.typeIt({
              content : '전체 지식맵을 토대로 단원 이해도를 측정 중입니다···',
            });
          }
          go();
        }
        setTimeout(type1, 1500);
        setTimeout(type2, 5000);
        setTimeout(type3, 11000);
      `;
      script.type = "text/javascript";
      script.async = "async";
      document.head.appendChild(script);
      setTimeout(() => {
        history.push("/diagnosis/result/");
      }, 15000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return auth ? <LoadingForm t_type={auth.t_type}></LoadingForm> : <p>no</p>;
};

export default withRouter(LoadingContainer);
